
const state = {
  status: false,
  facebookToken: null,
  routerTarget: null
}

const mutations = {
  setStatus (state, status) {
    state.status = status
  },
  setFacebookToken (state, accessToken) {
    state.facebookToken = accessToken
    localStorage.setItem('userFacebookToken', JSON.stringify(accessToken))
  },
  setRouterTarget (state, target) {
    state.routerTarget = target
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
